import React from "react";
import { Button } from "antd";

// App-wide error boundary. React can't recover from a render/lifecycle throw on
// its own — without a boundary, any throw unmounts the whole tree and white-screens
// the app. This is mounted at the app root (last-resort catch-all) and around each
// page in Layout (keyed by pathname, so a crashed page keeps the nav alive and the
// boundary resets automatically when the user navigates elsewhere).
//
// Kept intentionally dependency-light (no store/translate/CSS-class assumptions),
// since the thing that broke may be exactly those. Uses only Bootstrap's always-loaded
// `.btn` classes plus inline styles.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // No remote error reporting is configured; log for local debugging.
    console.error("ErrorBoundary caught an error:", error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{ padding: "48px 24px", textAlign: "center", maxWidth: 480, margin: "40px auto" }}>
        <div style={{ fontSize: 48, lineHeight: 1, marginBottom: 16 }}>⚠️</div>
        <h3 style={{ marginBottom: 8 }}>Something went wrong</h3>
        <p style={{ color: "#666", marginBottom: 24 }}>This page ran into an unexpected error. Reload to try again, or use the menu to open another page.</p>
        <Button type="primary" onClick={this.handleReload}>
          Reload
        </Button>
      </div>
    );
  }
}
